AGA.UserConfirmation = (function () {

    var allMessages = [];
    var current = null;

    function callback(metodo) {
        AGA.Ajax.callWebMethodBlocked(
            metodo,
            { parametro: current.handle },
            function (dados) { showCurrent(); eval(dados.d["CALLBACKJAVASCRIPT"]); },
            function (erro, mensagem) { alert(mensagem); showCurrent(); });
    }

    function yesCallback() {
        callback("AgaUserConfirmationYes");
    }

    function noCallback() {
        callback("AgaUserConfirmationNo");
    }

    function showCurrent() {
        if (allMessages.length === 0)
            return;
        current = allMessages[0];

        allMessages = allMessages.slice(1);

        if (current.tipo === 1)
            AGA.Helper.requestConfirmationCustom({
                title: "Confirmação solicitada",
                message: replaceAll(current.message, "\n", "<br />"),
                yesCallback: yesCallback,
                noCallback: noCallback
            })
        else
            AGA.Helper.showAlert({
                message: replaceAll(current.message, "\n", "<br />"),
                yesCallback: yesCallback
            });
    }

    function replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }



    function showAll() {
        var messages = $(".aga-user-confirmation");
        if (messages.length === 0)
            return;

        allMessages = messages.map(function (index, item) {
            return {
                handle: $(item).data("handle"),
                tipo: $(item).data("tipo"),
                message: $(item).html()
            };
        });

        $(".aga-user-confirmation").detach();
        showCurrent();
    };


    return {
        showAll: showAll
    }
})();

$(document).ready(function () {
    AGA.UserConfirmation.showAll();
});